import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "redux-store/store";

import { DIALOG_STATUS } from "helper/enum/dialogEnum";
import { getKeyWithQuery } from "../saga/category";

const staticSelector = (state: RootState) => state.static;

// dialog
const dialogSelector = createSelector(staticSelector, (state) => state.dialog);

export const isOpenDialogSelector = (key: string) =>
  createSelector(
    dialogSelector,
    (state) => state[key]?.status === DIALOG_STATUS.OPEN
  );

export const dialogPayloadSelector = (key: string) =>
  createSelector(dialogSelector, (state) => state[key]?.payload);

// location
const locationSelector = createSelector(
  staticSelector,
  (state) => state.location
);

export const provincesSelector = createSelector(
  locationSelector,
  (state) => state.province?.data?.["all"] ?? []
);

export const districtsSelector = createSelector(
  locationSelector,
  (state) => state.district.data
);

export const districtsOfProvinceSelector = (provinceCode: string) =>
  createSelector(districtsSelector, (state) => state[provinceCode] ?? []);

export const wardsSelector = createSelector(
  locationSelector,
  (state) => state.ward.data
);

export const wardsOfDistrictSelector = (districtCode: string) =>
  createSelector(wardsSelector, (state) => state[districtCode] ?? []);

// category
const categorySelector = createSelector(
  staticSelector,
  (state) => state.category
);

const categoryDataSelector = createSelector(
  categorySelector,
  (state) => state.data
);

export const categoryOptionsSelector = (
  categoryCode:
    | string
    | {
        type: string;
        query?: Record<string, any>;
        params?: Record<string, any>;
      }
) => {
  const storeKey: string =
    typeof categoryCode === "string"
      ? categoryCode
      : getKeyWithQuery(categoryCode?.type, {
          ...categoryCode?.query,
          ...categoryCode?.params,
        });
  return createSelector(categoryDataSelector, (state) => state[storeKey] ?? []);
};

// image

const fileSelector = createSelector(staticSelector, (state) => state.file);

const fileDataSelector = createSelector(fileSelector, (state) => state.data);

export const fileResponseSelector = (imageCode: string) =>
  createSelector(fileDataSelector, (state) => state[imageCode]?.data);

export const fileSelectorStatus = createSelector(
  fileSelector,
  (state) => state.status
);

// validation
const validationSelector = createSelector(
  staticSelector,
  (state) => state.validation
);

export const validationErrorsSelector = (validationKey: string) =>
  createSelector(validationSelector, (state) => state[validationKey] ?? {});

const monthYearSelectedSelector = createSelector(
  staticSelector,
  (state) => state.getMonthYearSelected
);

export const monthSelectedSelector = createSelector(
  monthYearSelectedSelector,
  (state) => state.month
);

export const yearSelectedSelector = createSelector(
  monthYearSelectedSelector,
  (state) => state.year
);

export const weekSelectedSelector = createSelector(
  monthYearSelectedSelector,
  (state) => state.week
);
